module.exports = __webpack_public_path__ + "img/img2.d47b35cd.svg";